// Re-export from AuthContext for backwards compatibility
export { useAuth } from '../contexts/AuthContext';
export type { AuthState } from '../contexts/AuthContext';
